import script from "./TrainList.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainList.vue?vue&type=script&setup=true&lang=js"

import "./TrainList.vue?vue&type=style&index=0&id=666f14de&lang=scss"

const __exports__ = script;

export default __exports__